import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResetFilter, ResetFiltersDescription, ZeroResultFilters } from 'autogen/translation-keys/trans-website-filter';
import { Button } from 'components/Button';
import { Typography } from 'components/generic/typography';
import Flex from 'components/Layout/components/Flex';
import useFilters from './ProductListFilter/shared/hooks/useFilters';

export default function ZeroResultProductList() {
    const { removeAllFilters } = useFilters();
    const { t } = useTranslation();
    return (
        <Flex.Column alignItems="start">
            <Typography.Title size="L">{t(ZeroResultFilters)}</Typography.Title>
            <Typography.Body as="span" size="L">
                {t(ResetFiltersDescription)}
            </Typography.Body>
            <Button size="lg" onClick={removeAllFilters}>
                {t(ResetFilter)}
            </Button>
        </Flex.Column>
    );
}
